<template>
  <div class="block">
    <v-layout row class="mt-2 pb-3" v-for="i in items" :key="i">
      <v-flex xs3>
        <p class="settings-label subheader text-xs-right">{{ i }}</p>
      </v-flex>
      <v-flex xs5 class="pl-4">
        <v-text-field
              name="input-1"
              label="Title Text"
              id="testing"
              v-model="data.header"
        ></v-text-field>
        <v-text-field
          name="input-7-1"
          label="Subtitle Text"
          multi-line
          v-model="data.sub_text"
        ></v-text-field>
        <v-btn
          color="primary"
          :style="{backgroundColor: styles.general.theme_color_light}"
          :loading="loading"
          @click.prevent="submitData(values)"
          :disabled="loading"
          :id="type"
        >
          Save
          <span slot="loader" class="custom-loader">
              <v-icon light>cached</v-icon>
          </span>
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
export default {
  props: ['items', 'submitData', 'loading', 'type', 'data'],
  data () {
    return {
      values: {
        type: this.type,
        data: this.data
      }
    }
  },
  computed: {
    styles () {
      return this.$store.getters.getStyles
    }
  }
}
</script>



// WEBPACK FOOTER //
// single_block.vue?0e711148